
import { useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import AdminRoute from "@/components/auth/AdminRoute";
import AIChatInterface from "@/components/ai-chat/AIChatInterface";
import PromptSelector from "@/components/ai-chat/PromptSelector";

const AIChatPage = () => {
  const [selectedPrompt, setSelectedPrompt] = useState<string | null>(null);
  
  return (
    <AdminRoute>
      <div className="min-h-screen flex flex-col bg-background">
        <Navbar />
        
        <div className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-6xl">
            <header className="mb-8">
              <h1 className="text-3xl font-bold mb-2">AI Chat (Admin Preview)</h1>
              <p className="text-muted-foreground">
                Test prompts from the hub in a real chat interface. This feature is currently in admin preview.
              </p>
            </header>
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-1">
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-border/40 overflow-hidden p-6">
                  <h2 className="text-xl font-semibold mb-4">Select a Prompt</h2>
                  <PromptSelector 
                    onPromptSelect={(promptId) => setSelectedPrompt(promptId)} 
                    selectedPrompt={selectedPrompt}
                  />
                </div>
              </div>
              
              <div className="lg:col-span-2">
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-border/40 overflow-hidden h-[600px] flex flex-col">
                  <AIChatInterface promptId={selectedPrompt} />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </AdminRoute>
  );
};

export default AIChatPage;
